// FILECONTENT_START src/common/components/DataGrid/toolbar-buttons/DatagridToolbarButtonContainer.tsx
import { Box, BoxProps } from "@mui/material";

interface DataGridToolbarButtonContainerProps extends BoxProps {}

export default function DataGridToolbarButtonContainer({
  children,
  ...props
}: DataGridToolbarButtonContainerProps) {
  return (
    <Box sx={{ paddingLeft: 0.5, paddingRight: 0.5 }} {...props}>
      {children}
    </Box>
  );
}

// FILECONTENT_END src/common/components/DataGrid/toolbar-buttons/DatagridToolbarButtonContainer.tsx